import { isValidUrl } from '@src/utils/urlUtils';

/**
 * お問い合わせフォームの方式（内部フォーム/外部URL）を切り替えるための値を返す。
 * AWS Parameter Storeは空文字を許容しないため、未設定のテナントにはプレースホルダ値
 * （URLとして無効な文字列）が設定される。有効なURLの場合のみ「外部URL方式」とみなす。
 */
export function getCompanyContactUrl(): string | undefined {
  const url = import.meta.env.VITE_COMPANY_CONTACT_URL;
  return isValidUrl(url) ? url : undefined;
}
